import apiAxiosClient from './apiAxiosClient2';
import {
    QUESTIONS_GPLX_CODE,
} from './questionsGPLXCode';

import {
    QUESTIONS_ALL,
} from './questionsAll';

// import {
//     QUESTIONS_TEST,
// } from './questionsTest';

import { shuffleArray } from '~/utils/common';
import { getConfigForTest, getGPLXCode, getLesson } from '~/utils/600bca';
const NUMBER_QUESTION = 10

function getRandom(arr, size = NUMBER_QUESTION) {
    // copy mảng để không thay đổi mảng gốc
    const clone = [...arr];

    // Fisher–Yates shuffle (xáo trộn chuẩn)
    for (let i = clone.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [clone[i], clone[j]] = [clone[j], clone[i]];
    }

    // lấy 10 phần tử đầu sau khi shuffle
    return clone.slice(0, size);
}

function chunkArray(arr, size = NUMBER_QUESTION) {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
        result.push(arr.slice(i, i + size));
    }
    return result;
}

function compressRanges(arr) {
    if (arr.length === 0) return "";

    let result = [];
    let start = arr[0];
    let prev = arr[0];

    for (let i = 1; i < arr.length; i++) {
        const curr = arr[i];

        if (curr === prev + 1) {
            // vẫn nằm trong chuỗi liên tiếp
            prev = curr;
        } else {
            // kết thúc 1 range
            result.push(start === prev ? `${start}` : `${start}-${prev}`);
            start = curr;
            prev = curr;
        }
    }

    // đẩy range cuối cùng
    result.push(start === prev ? `${start}` : `${start}-${prev}`);

    return result.join(", ");
}

function notFound() {
    return {
        "data": {
            "code": "04",
            "mes": "Not Found."
        }
    }
}

const quizApi = {
    searchBooks(params) {
        const url = '/api/search-books';
        return apiAxiosClient.post(url, params);
    },

    async getBook(params) {
        if (params.id === "600bca") {
            const gplxCode = localStorage.getItem('gplxCode')
            const questionsGPLXCode = QUESTIONS_GPLX_CODE.filter(item => item.codes.includes(gplxCode));

            const lessons = []
            // tạo lesson phần Học theo thứ tự
            questionsGPLXCode.forEach((ele, index) => {
                const exercises = []
                const chunk = chunkArray(ele.questions);
                chunk.forEach((arr, i) => {
                    if (arr.length > 0) {
                        exercises.push({
                            "id": arr[0] + "-" + arr[arr.length - 1],
                            "type": "multiple-choices",
                            "name": "Câu " + compressRanges(arr),
                            "shuffle": false,
                            "questions": null,
                            "no": i + 1
                        });
                    }
                });
                lessons.push({
                    "id": ele.id,
                    "no": index + 1,
                    "tittle": ele.name + " (" + ele.questions.length + " câu)",
                    "exercises": exercises
                });
            });

            const exercisesRandom = [
                {
                    "id": "test",
                    "type": "multiple-choices",
                    "name": "Thi thử",
                    "shuffle": false,
                    "questions": null,
                    "no": 1
                },
                {
                    "id": "all",
                    "type": "multiple-choices",
                    "name": "Tất cả",
                    "shuffle": false,
                    "questions": null,
                    "no": 2
                }
            ]
            questionsGPLXCode.forEach((ele, index) => {
                if (ele.questions.length > 0) {
                    exercisesRandom.push({
                        "id": ele.id,
                        "type": "multiple-choices",
                        "name": ele.name,
                        "shuffle": false,
                        "questions": null,
                        "no": exercisesRandom.length + 1
                    });
                }
            });
            // tạo lesson phần Ngẫu nhiên
            lessons.push({
                "id": "random",
                "no": lessons.length + 1,
                "tittle": "Ngẫu nhiên",
                "exercises": exercisesRandom
            });

            return {
                "status": 200,
                "statusText": "OK",
                "data": {
                    "code": "00",
                    "mes": "success",
                    "data": {
                        "id": "600bca",
                        "name": "Thi GPLX - 600 Câu của BCA 2025",
                        "pubisher": "Bộ Công An",
                        "language": "Vietnamese",
                        "authors": [
                            "Bộ Công An"
                        ],
                        "lessons": lessons,
                    }
                }
            }
        }
        const url = '/api/get-book';
        return apiAxiosClient.post(url, params);
    },

    async getExercise(params) {
        // console.log('params', params)
        const bookId = params.bookId;
        const lessonId = params.lessonId;
        const id = params.id;

        if (bookId === "600bca") {
            const gplxCode = getGPLXCode();
            if (lessonId === "random" && id === "test") {
                const testConfig = getConfigForTest(gplxCode);
                // console.log('testConfig', testConfig)
                const lessonImportant = getLesson(gplxCode, "important");
                // console.log('lessonImportant', lessonImportant)

                const questionsNo = [];
                const keys = ["chapter1", "chapter2", "chapter3", "chapter4", "chapter5", "chapter6", "important"]
                keys.forEach(key => {
                    const lesson = getLesson(gplxCode, key);
                    // console.log('lesson', key, lesson)
                    // console.log('testConfig[key]', testConfig[key])

                    // bỏ câu quan trọng trong ds chương
                    let list = lesson.questions
                    if (key !== "important")
                        list = lesson.questions.filter(q => !lessonImportant.questions.includes(q))
                    // console.log('list', list)
                    // console.log('testConfig[key]', testConfig[key])
                    const aaa = getRandom(list, testConfig[key]);
                    // console.log('aaa', aaa)
                    questionsNo.push(...aaa)
                });
                // console.log('questionsNo', questionsNo)
                const questions = shuffleArray(QUESTIONS_ALL.filter(ques => questionsNo.includes(ques.no)))
                // console.log('questions', questions)
                if (questions.length < 1) {
                    return notFound();
                }
                return {
                    "data": {
                        "code": "00",
                        "mes": "success",
                        "data": {
                            "id": id,
                            "type": "multiple-choices",
                            "name": "Thi GPLX - 600 Câu của BCA 2025",
                            "shuffle": false,
                            "no": 1,
                            "questions": questions
                        }
                    }
                }
            }

            if (lessonId === "random") {
                let randomQuestionsNo;
                if (id === "all") {
                    const lessonAll = QUESTIONS_GPLX_CODE.filter(item => item.codes.includes(gplxCode) && item.id !== "important");
                    if (lessonAll.length < 1) {
                        return notFound();
                    }
                    // console.log('lessonAll', lessonAll)
                    const allQuestionsNo = []
                    lessonAll.forEach(lesson => {
                        allQuestionsNo.push(...lesson.questions)
                    });
                    randomQuestionsNo = getRandom(allQuestionsNo);
                } else {
                    const lesson = QUESTIONS_GPLX_CODE.filter(item => item.codes.includes(gplxCode) && item.id === id);
                    // console.log('lesson', lesson)
                    if (lesson.length !== 1) {
                        return notFound();
                    }
                    randomQuestionsNo = getRandom(lesson[0].questions);
                }
                // console.log('randomQuestionsNo', randomQuestionsNo)

                const questions = shuffleArray(QUESTIONS_ALL.filter(ques => randomQuestionsNo.includes(ques.no)))
                if (questions.length < 1) {
                    return notFound();
                }

                return {
                    "data": {
                        "code": "00",
                        "mes": "success",
                        "data": {
                            "id": id,
                            "type": "multiple-choices",
                            "name": "Thi GPLX - 600 Câu của BCA 2025",
                            "shuffle": false,
                            "no": 1,
                            "questions": questions
                        }
                    }
                }

            } else {

                const lesson = QUESTIONS_GPLX_CODE.filter(item => item.codes.includes(gplxCode) && item.id === lessonId);
                // console.log('lesson', lesson)
                if (lesson.length !== 1) {
                    return notFound();
                }

                const [start, end] = id.split("-").map(Number);
                // console.log('start', start)
                // console.log('end', end)
                if (!start || !end) {
                    return notFound();
                }
                const questionsNo = lesson[0].questions.filter(item => item >= start && item <= end);
                // console.log('questionsNo', questionsNo)
                const questions = QUESTIONS_ALL.filter(ques => questionsNo.includes(ques.no))
                if (questions.length < 1) {
                    return notFound();
                }
                return {
                    "data": {
                        "code": "00",
                        "mes": "success",
                        "data": {
                            "id": id,
                            "type": "multiple-choices",
                            "name": "Thi GPLX - 600 Câu của BCA 2025",
                            "shuffle": false,
                            "no": 1,
                            "questions": questions
                        }
                    }
                }
            }
        }
        const url = '/api/get-exercise';
        return apiAxiosClient.post(url, params);
    },
};

export default quizApi;
